import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
interface IProps {
    isReadOnly: boolean
}
export default function TravelPlanPublicTransportV1({ isReadOnly }: IProps) {
    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;

    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {hasValues(["coveredBusShelterWithin400mOfSite", "coveredBusShelterWithin400mOfSiteMonth", "coveredBusShelterWithin400mOfSiteYear", "coveredBusShelterWithin400mOfSiteCapitalCost", "coveredBusShelterWithin400mOfSiteAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="coveredBusShelterWithin400mOfSite" label="Bus waiting facilities (clean, grafitti-free bus shelter and seats close to (e.g. within 400 metres) the site's main enterance" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'coveredBusShelterWithin400mOfSiteMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'coveredBusShelterWithin400mOfSiteYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="coveredBusShelterWithin400mOfSiteCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="coveredBusShelterWithin400mOfSiteAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["pedestrianRoutesToRailwayStations400m", "pedestrianRoutesToRailwayStations400mMonth", "pedestrianRoutesToRailwayStations400mYear", "pedestrianRoutesToRailwayStations400mCapitalCost", "pedestrianRoutesToRailwayStations400mAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="pedestrianRoutesToRailwayStations400m" label="Secure well-lit pedestrian routes to bus/tram stops within 400 metres" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'pedestrianRoutesToRailwayStations400mMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'pedestrianRoutesToRailwayStations400mYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="pedestrianRoutesToRailwayStations400mCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="pedestrianRoutesToRailwayStations400mAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["transportInfoProvidedOnsite", "transportInfoProvidedOnsiteMonth", "transportInfoProvidedOnsiteYear", "transportInfoProvidedOnsiteCapitalCost", "transportInfoProvidedOnsiteAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="transportInfoProvidedOnsite" label="Public transport information provided on site on paper and/or computer" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'transportInfoProvidedOnsiteMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'transportInfoProvidedOnsiteYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="transportInfoProvidedOnsiteCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="transportInfoProvidedOnsiteAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["personalisedPlanningOrTravelAssistance", "personalisedPlanningOrTravelAssistanceMonth", "personalisedPlanningOrTravelAssistanceYear", "personalisedPlanningOrTravelAssistanceCapitalCost", "personalisedPlanningOrTravelAssistanceAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="personalisedPlanningOrTravelAssistance" label="Personalised journey planning travel assistance (e.g. helpline, etc)" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'personalisedPlanningOrTravelAssistanceMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'personalisedPlanningOrTravelAssistanceYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="personalisedPlanningOrTravelAssistanceCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="personalisedPlanningOrTravelAssistanceAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["newOrImprovedBusServicesClosetoSite", "newOrImprovedBusServicesClosetoSiteMonth", "newOrImprovedBusServicesClosetoSiteYear", "newOrImprovedBusServicesClosetoSiteCapitalCost", "newOrImprovedBusServicesClosetoSiteAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="newOrImprovedBusServicesClosetoSite" label="New/improved bus services close to the site" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'newOrImprovedBusServicesClosetoSiteMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'newOrImprovedBusServicesClosetoSiteYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="newOrImprovedBusServicesClosetoSiteCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="newOrImprovedBusServicesClosetoSiteAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["pedestrianRoutesToRailwayStations1000m", "pedestrianRoutesToRailwayStations1000mMonth", "pedestrianRoutesToRailwayStations1000mYear", "pedestrianRoutesToRailwayStations1000mCapitalCost", "pedestrianRoutesToRailwayStations1000mAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="pedestrianRoutesToRailwayStations1000m" label="Secure well-lit pedestrian routes to railway stations within 1000 metres" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'pedestrianRoutesToRailwayStations1000mMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'pedestrianRoutesToRailwayStations1000mYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="pedestrianRoutesToRailwayStations1000mCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="pedestrianRoutesToRailwayStations1000mAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["publicityAndAwarenessMaterial", "publicityAndAwarenessMaterialMonth", "publicityAndAwarenessMaterialYear", "publicityAndAwarenessMaterialCapitalCost", "publicityAndAwarenessMaterialAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="publicityAndAwarenessMaterial" label="Publicity and awareness raising material about local public transport" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'publicityAndAwarenessMaterialMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'publicityAndAwarenessMaterialYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="publicityAndAwarenessMaterialCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="publicityAndAwarenessMaterialAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    <Grid container size={12}>
                        <Grid size={12}>
                            <Typography variant={"h6"}>Additional comments</Typography>
                        </Grid>
                        <RenderTextField name="publicTransportComments" readOnly={isReadOnly} multiLine={true} rows={4} inputSize={12} alwaysShow={true} />
                    </Grid>
                </Grid>
            </Grid>

        </>
    );
}
